import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { FaChevronDown } from 'react-icons/fa';
import { EmployeeAvatar } from '../../../../../../common/EmployeeAvatar';
import { getColor, getDisplayName, getDefaultLevelId } from '../../../../../../../constants/skillLevels';

const ReviewerCompetency = ({ 
  reviewer, 
  competencyLevelId,
  showDropdownArrow = false,
  onClick = null,
  isInteractive = false,
  opacity = 1,
  additionalInfo = null,
  hideReviewer = false,
  skillLevels,
  loading = false,
  showSkillLevels = true
}) => {
  const defaultLevelId = getDefaultLevelId(skillLevels);
  const levelId = competencyLevelId || defaultLevelId;
  
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: hideReviewer ? 'auto' : '400px' }}>
      {!hideReviewer && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1, opacity: opacity }}>
          <EmployeeAvatar employee={reviewer.employee} size={32} />
          <Box>
            <Typography sx={{ fontWeight: 500 }}>
              {reviewer.employee.fullName}
            </Typography>
            {additionalInfo && (
              <Typography variant="caption" color="text.secondary">
                {additionalInfo}
              </Typography>
            )}
          </Box>
        </Box>
      )}
      {showSkillLevels && (
        <Box 
          onClick={isInteractive && !loading ? onClick : undefined}
          sx={{ 
            width: hideReviewer ? '145px' : '200px',
            p: 1.5,
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            cursor: isInteractive && !loading ? 'pointer' : 'default',
            backgroundColor: getColor(levelId, skillLevels),
            opacity,
            transition: 'all 0.2s ease',
            '&:hover': {
              opacity: isInteractive && !loading ? 0.9 : opacity
            }
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box
              sx={{
                width: 12,
                height: 12,
                borderRadius: '50%',
                backgroundColor: getColor(levelId, skillLevels),
                border: '1px solid #333'
              }}
            />
            <Typography sx={{ 
              color: '#000',
              fontSize: '13px'
            }}>
              {getDisplayName(levelId, skillLevels)}
            </Typography>
          </Box>
          {loading ? (
            <CircularProgress size={14} thickness={4} sx={{ color: '#000' }} />
          ) : (
            showDropdownArrow && <FaChevronDown size={12} color="#000" />
          )}
        </Box>
      )}
    </Box>
  );
};

export default ReviewerCompetency; 